"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EmbedPlayer = require("./EmbedPlayer");
Object.keys(_EmbedPlayer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmbedPlayer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EmbedPlayer[key];
    }
  });
});